import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';

import { State } from '@wam/shared';
import * as authenticationActions from './state/authentication.actions';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
  selector: 'logged-in',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export class LoggedInComponent implements OnInit {
  private store = inject<Store<State>>(Store);
  // @ts-ignore
  private window = inject<Window>('window');

  ngOnInit(): void {
    const queryParams = new URLSearchParams(this.window.location.search);

    const idToken = queryParams.get('idToken');
    const refreshToken = queryParams.get('refreshToken');
    const clientId = queryParams.get('clientId');
    const logoutUrl = queryParams.get('logoutRedirectUrl') ?? undefined;
    const includeLogoutToken =
      coerceBooleanProperty(queryParams.get('includeLogoutToken')) || undefined;

    const documentId = queryParams.get('documentId') || undefined;
    if (documentId !== undefined) {
      localStorage.setItem('documentId', `${documentId}`);
    }

    if (idToken && clientId) {
      this.store.dispatch(
        authenticationActions.authorizeWithTokens({
          idToken,
          refreshToken,
          logoutUrl,
          includeLogoutToken,
        }),
      );
      this.store.dispatch(authenticationActions.updateClientId({ clientId }));
    } else if (idToken) {
      this.store.dispatch(
        authenticationActions.authorizeWithTokens({
          idToken,
          refreshToken,
          logoutUrl,
          includeLogoutToken,
        }),
      );
    }
  }
}
